/**
 * DEVELOPER DOCUMENTATION
 * Include your custom JavaScript here.
 * Quartz theme - Zentavo customizations
 */

(function() {
  'use strict';

  // Alleen uitvoeren op shop/collection pagina's
  var isProductPage = window.location.pathname.includes('/products/');
  var isCollectionPage = window.location.pathname.includes('/collections/');

  // ============================================================
  // CSS INJECTEREN
  // ============================================================
  var css = '';

  // Shop pagina — hover reveal op product cards
  if (isCollectionPage && !isProductPage) {
    css += `
      .product-item {
        position: relative;
        transition: transform 0.4s cubic-bezier(0.16,1,0.3,1);
      }
      .product-item:hover {
        transform: translateY(-5px);
      }
      .product-item__primary-image {
        transition: transform 0.6s cubic-bezier(0.16,1,0.3,1) !important;
      }
      .product-item:hover .product-item__primary-image {
        transform: scale(1.05) !important;
      }
      .z-card-overlay {
        position: absolute;
        bottom: 0; left: 0; right: 0;
        background: rgba(10,10,10,0.9);
        backdrop-filter: blur(4px);
        padding: 20px 18px;
        transform: translateY(100%);
        transition: transform 0.45s cubic-bezier(0.16,1,0.3,1);
        z-index: 10;
      }
      .product-item:hover .z-card-overlay {
        transform: translateY(0);
      }
      .z-card-overlay-title {
        font-family: 'Palatino Linotype', Palatino, serif;
        font-size: 10px;
        letter-spacing: 4px;
        text-transform: uppercase;
        color: #fff;
        margin-bottom: 10px;
        opacity: 0;
        transform: translateY(6px);
        transition: opacity 0.3s ease 0.1s, transform 0.3s ease 0.1s;
      }
      .product-item:hover .z-card-overlay-title { opacity: 1; transform: translateY(0); }
      .z-card-overlay-price {
        font-family: 'Palatino Linotype', Palatino, serif;
        font-size: 13px;
        letter-spacing: 2px;
        color: #ccc;
        margin-bottom: 14px;
        opacity: 0;
        transform: translateY(6px);
        transition: opacity 0.3s ease 0.15s, transform 0.3s ease 0.15s;
      }
      .product-item:hover .z-card-overlay-price { opacity: 1; transform: translateY(0); }
      .z-card-overlay-btn {
        display: block;
        width: 100%;
        padding: 11px 16px;
        background: transparent;
        color: #fff;
        border: 1px solid rgba(255,255,255,0.4);
        font-family: 'Palatino Linotype', Palatino, serif;
        font-size: 9px;
        letter-spacing: 5px;
        text-transform: uppercase;
        text-align: center;
        text-decoration: none;
        box-sizing: border-box;
        transition: background 0.3s, color 0.3s, border-color 0.3s, opacity 0.3s ease 0.2s, transform 0.3s ease 0.2s;
        opacity: 0;
        transform: translateY(6px);
      }
      .product-item:hover .z-card-overlay-btn { opacity: 1; transform: translateY(0); }
      .z-card-overlay-btn:hover { background: #fff; color: #0a0a0a; border-color: #fff; }
    `;
  }

  if (css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ============================================================
  // HOVER OVERLAY INJECTEREN IN PRODUCT CARDS
  // ============================================================
  if (isCollectionPage && !isProductPage) {
    function injectOverlays() {
      document.querySelectorAll('.product-item:not([data-z])').forEach(function(item) {
        item.setAttribute('data-z', '1');
        var wrapper = item.querySelector('.product-item__image-wrapper');
        if (!wrapper) return;
        var titleEl = item.querySelector('.product-item-meta__title');
        var priceEl = item.querySelector('.price:not(.price--compare)');
        var linkEl  = item.querySelector('a[href*="/products/"]');
        var title = titleEl ? titleEl.innerText.trim() : '';
        var price = priceEl ? priceEl.innerText.trim() : '';
        var href  = linkEl  ? linkEl.getAttribute('href') : '#';
        wrapper.style.position = 'relative';
        wrapper.style.overflow = 'hidden';
        var ov = document.createElement('div');
        ov.className = 'z-card-overlay';
        ov.innerHTML =
          '<div class="z-card-overlay-title">' + title + '</div>' +
          '<div class="z-card-overlay-price">' + price + '</div>' +
          '<a href="' + href + '" class="z-card-overlay-btn">View details</a>';
        wrapper.appendChild(ov);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectOverlays);
    } else {
      injectOverlays();
    }

    new MutationObserver(injectOverlays).observe(document.body, { childList: true, subtree: true });
  }

})();
